import { render, staticRenderFns } from "./ApplicationInReview.vue?vue&type=template&id=25c07fcf&"
import script from "./ApplicationInReview.vue?vue&type=script&lang=js&"
export * from "./ApplicationInReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports